<template>
    <v-app id="inspire2">
        <sendModal 
            ref="dialog"
        />
        <v-content style="position: relative; z-index: 4;">
            <v-container
              fluid
              style="max-width: 900px"
            >
                <div class="title mb-5 mt-5 pt-5 text-center" style="margin-top: 60px !important;">Для получения расчета оставьте свои контактные данные</div>
                <v-row
                    align="center"
                    justify="center"
                >
                    <v-col
                        cols="12"
                        sm="10"
                        md="8"
                    >
                        <v-form
                            ref="form"
                            v-model="validPrint"
                            lazy-validation
                        >
                            <v-text-field
                                v-model="form.nameOrg"
                                :rules="minRequere"
                                label="Наименование организации"
                                outlined
                            >
                            </v-text-field>
                        
                            <v-text-field
                                v-model="form.email"
                                :rules="email"
                                label="Email"
                                outlined
                            >
                            </v-text-field>

                            <v-text-field
                                v-model="form.phone"
                                :rules="phone"
                                label="Телефон"
                                v-mask="mask"
                                placeholder="+7"
                                outlined
                            >
                            </v-text-field>
                        </v-form>
                        <v-row
                            align="center"
                            justify="center"
                        >
                            <v-btn
                                :loading="loadingTell"
                                color="success"
                                class="mr-4 mt-2"
                                @click="sendTellMy()"
                            >
                                Позвоните мне
                            </v-btn>
                            <v-btn
                                :loading="loadingEmail"
                                color="success"
                                class="mr-4 mt-2"
                                @click="sendToEmail()"
                            >
                                Отправить на email
                            </v-btn>
                            <v-btn
                                :loading="loadingPrint"
                                color="success"
                                class="mr-4 mt-2"
                                @click="toPrint()"
                            >
                                Распечатать
                            </v-btn> 
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
        <div class="background-footer"></div>
    </v-app>
</template>

<script>
    import { mapState } from 'vuex'
    import { mask } from 'vue-the-mask'
    import $axios from '@/plugins/axios-instance'
    import axios from 'axios';
    import sendModal from './modal/send'

    const  fileDownload = require('js-file-download');

    export default {
        data() {
            return {
                validPrint: true,
                loadingEmail: false,
                loadingPrint: false,
                loadingTell: false,
                mask: '+7 ### ### ## ##',
                form: {
                    name: '',
                    nameOrg: '',
                    phone: '+7',
                    email: '',
                },

                minRequere: [
                    v => !!v || 'Заполните это поле',
                ],
                email: [
                    v => !!v || 'Заполните это поле',
                    v => /.+@.+\..+/.test(v) || 'Введите E-mail',
                ],
                phone: [
                    v => !!v || 'Заполните это поле',
                    v => /^((\+7|7|8)+([0-9]){10})$/.test(v.replace(/\s/g, '')) || 'Введите номер телефона',
                ],
            }
        },
        computed: mapState({
            step1: state => state.step1,
            step2: state => state.step2,
        }),
        methods: {
            async sendTellMy () {
                if (this.$refs.form.validate()) {
            
                    let data = {
                        "HouseCount": this.$route.params.data.houseCount,
                        "HouseSquare": this.$route.params.data.houseArea,
                        "OrganizationName": this.form.nameOrg,
                        "Email": this.form.email,
                        "Phone": this.form.phone,
                        "Offers": this.$route.params.dataConvert
                    }
                    this.loadingTell = true
                    try {

                        await $axios.post(`/RequestCallOffer`, data)
                        .then((response) => {
                            this.$refs.dialog.openDialog({
                                title: 'Спасибо за заявку!',
                                text: 'Мы свяжемся с вами в ближайшее время. <br> А если нет времени ждать — позвоните нам сами:<br><br> <b>8 (861) 290-04-05</b>'
                            })
                        }).catch((e)=>{
                            throw(e)
                        })

                    } catch(e) {
                        this.$errorsMod(e.response)
                    }
                    this.loadingTell = false

                }
            },
            async toPrint() {
                if (this.$refs.form.validate()) {
                    
                    let data = {
                        "HouseCount": this.$route.params.data.houseCount,
                        "HouseSquare": this.$route.params.data.houseArea,
                        "OrganizationName": this.form.nameOrg,
                        "Email": this.form.email,
                        "Phone": this.form.phone,
                        "Offers": this.$route.params.dataConvert
                    }
                    this.loadingPrint = true

                    try {
                        await $axios.post(`/PrintOffer`, data, {
                             responseType: 'blob'
                        })
                        .then((response) => {
                            fileDownload(response.data, 'отчет.pdf')
                        }).catch((e)=>{
                            throw(e)
                        })
                    } catch(e) {
                        this.$errorsMod(e.response)
                    }

                    this.loadingPrint = false


                }
            },
            async sendToEmail() {
                if (this.$refs.form.validate()) {
                    let data = {
                        "HouseCount": this.$route.params.data.houseCount,
                        "HouseSquare": this.$route.params.data.houseArea,
                        "OrganizationName": this.form.nameOrg,
                        "Email": this.form.email,
                        "Phone": this.form.phone,
                        "Offers": this.$route.params.dataConvert
                    }

                    this.loadingEmail = true

                    try {
                        await $axios.post(`/SendOffer`, data)
                        .then((response) => {
                            this.$refs.dialog.openDialog({
                                title: 'Мы отправили расчет!',
                                text: 'Он ждет вас на электронной почте.<br><br> Почтовики — всего лишь роботы, и они не идеальны. Если письмо почему-то не пришло – пожалуйста, сообщите нам об этом: <br><br> <a href="mailto:sales@jfservice.ru">sales@jfservice.ru</a> <br><br> <b>8 (861) 290-04-05</b>'
                            })
                        }).catch((e)=>{
                            throw(e)
                        })

                    } catch(e) {
                        this.$errorsMod(e.response)
                    }

                    this.loadingEmail = false

                }
            }

        },
        components: {
            sendModal
        },
        directives: {
            mask,
        },
        mounted() {
            console.log('dataConvert', this.$route.params.dataConvert)
        }
    }
</script>

<style scoped>
    .theme--dark.v-card > .v-card__text, .theme--dark.v-card .v-card__subtitle{
        color: #FFF !important;
    }
    
    .block-icon i {
        font-size: 249px;
        position: absolute;
        right: -43px;
        top: 33px;
        color:rgba(0, 0, 0, 0.13);
        z-index: 1;
    }

    .block-form {
        display: flex;
        flex-direction: column;
        height: 200px;
        max-width: 300px;
        justify-content: flex-start;
    }

    .row-line {
        background-image: url('/rope.png');
        width: 300px;
        height: 135px;
        background-size: 105px;
        background-position: 170px 50px;
        opacity: 0.8;
    }
    .right-rope {
        transform: scale(-1, 1);
    }

    .background-footer {
        position: absolute;
        bottom: 0;
        background-image: url('/city.png');
        height: 600px;
        background-size: 100%;
        opacity: 0.2;
        z-index: 1;
        background-position-x: center;
        background-position-y: -150px;
        width: 1000px;
        margin: 0 auto;
        right: 0;
        left: 0;
    }


    @media (max-width: 900px) {
        .row-line {
            display: none;
        }

        .block-form {
            height: 150px;
        }
    }

</style>